import { ECanPublishAsOwnerStatus, TCanPublishAsOwnerMappers } from './types';

export const mappers: TCanPublishAsOwnerMappers = {
  200: state => ({
    canPostAsOwner: state.canPostAsOwner,
    message: null,
    status: ECanPublishAsOwnerStatus.Success,
  }),
  400: ({ message }) => ({
    message,
    canPostAsOwner: false,
    status: ECanPublishAsOwnerStatus.Error,
  }),
};
